__turbopack_context__.v({
  "bazaarvoice-review-photos-gallery": "bazaarvoice-review-photos-gallery-module-scss-module__Lgs_-W__bazaarvoice-review-photos-gallery",
});
